var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgALineImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.0959,
    cy: 13.3453,
    r: 9,
    transform: "rotate(-42.4965 13.0959 13.3453)",
    fill: "white",
    stroke: "#31B4F2",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4079 14.8192L15.4762 13.7693L13.2945 15.7682L14.1799 17.7767L13.0769 18.7873L9.8738 11.0252L11.0579 9.94024L18.5109 13.8085L17.4079 14.8192ZM14.3912 13.1224L12.521 12.0907C12.435 12.0403 12.3109 11.97 12.1488 11.8798C11.9816 11.7843 11.8172 11.6863 11.6555 11.5858C11.4889 11.4799 11.3499 11.3933 11.2387 11.3262C11.3157 11.4645 11.397 11.6238 11.4825 11.804C11.5735 11.9792 11.657 12.1464 11.7331 12.3054C11.8146 12.4595 11.8718 12.5762 11.9046 12.6555L12.761 14.616L14.3912 13.1224Z",
    fill: "#363948"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgALineImg);
export default __webpack_public_path__ + "static/media/a-line-img.25589a12942aab9cd968232c5e0bba78.svg";
export { ForwardRef as ReactComponent };